<template>
  <div>
    <vue-scroll class="page-dashboard">
      <!-- <rabbey-toolbox
          :call-new="callNew"
          v-if="
            IsInRoles([
              roles.GerenteDeSoporte,
              roles.SuperUsuario,
              roles.EncargadaCompras,
              roles.GerenteRRHH,
              roles.SupervisorDeTécnicos,
              roles.GerenciaGeneral,
              roles.CoordinadorIso,
              roles.DirectorDeProyectos,
              roles.CoordinadorDeSoporte,
              roles.DirectorAdministrativo,
              roles.CoornidadorDeServicioAlCliente,
              roles.EncargadoDesarrolloDeAplicaciones,
  
              roles.CEO,
              roles.SupervisorDeSoporteDeVentas,
              roles.SupervisorDeVentas
            ])
          "
        /> -->
      <div
        class="flex gaps column demo-drawer__content border-myborder"
        style="padding: 20px"
      >
        <div id="div-legal">
          <CreateDocument @success="getTableData"></CreateDocument>
        </div>
      </div>
      <el-row id="tablep">
        <el-col>
          <rabbey-table3
            ref="table"
            :data="items"
            :columns="columns"
            :actions="actions"
            :loading="loading"
            :load="getTableData"
            @success="getTableData"
            @rtable-push-action="actionHandler"
            @update-page-size="updatePageSize"
            @update-current-page="updateCurrentPage"
          />
        </el-col>
      </el-row>
    </vue-scroll>

    <el-dialog title="Confirmación" :visible.sync="dialogVisible" width="10%">
      <span>¿Está seguro de eliminar este archivo?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="danger" size="mini"
          >Cancelar</el-button
        >
        <el-button type="primary" @click="deleteFile" size="mini"
          >Sí, eliminar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title=" Editar Documentos"
      :visible.sync="dialogVisible2"
      append-to-body
      width="22%"
    >
      <el-form
        label-position="top"
        :model="form"
        ref="form_create"
        style="position: relative; bottom: 29px"
      >
        <el-form-item
          style="margin-top: 30px; font-weight: bold; width: 360px"
          label="Nombre del archivo"
          :prop="folderName"
        >
          <el-input
            v-model="folderName"
            placeholder="Escribir el nombre del archivo"
            class="fields"
          ></el-input>
        </el-form-item>

        <el-form-item label="Adjuntar documento" style="font-weight: bold">
          <el-upload
            ref="uploadFile"
            class="upload-demo"
            :drag="true"
            action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
            :file-list="fileList"
            :auto-upload="false"
            :multiple="true"
            :on-success="handleUploadOnSuccess"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Suelta tu archivo aquí o <em>haz clic para cargar</em>
            </div>
            <div slot="tip" class="el-upload__tip">
              Solo archivos con un tamaño menor de 4MG
            </div>
          </el-upload>
        </el-form-item>
        <el-button type="primary" size="mini" @click="dialogVisible2 = false"
          >Cancel</el-button
        >
        <el-button id="btnSave" type="primary" size="mini" @click="saveDocument"
          >Guardar</el-button
        >
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import { log } from "console";
// import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import CreateDocument from "./TableDocumentsPro.vue";

//import ImagePerson from "../components/functionals/ImagePerson.vue";

export default {
  name: "DocumentList",
  components: {
    CreateDocument
  },
  created() {
    this.getTableData();
    this.saves();
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      fileList: [],
      folderName: "",
      isEnabled: true,
      count: 0,
      fileId: 0,
      ModuleId: 3,
      selectedFile: 0,
      fileCreatedBy: 0,
      currentPage: 1,
      pageSize: 4,
      items: [],
      itemId: -1,
      loading: false,
      legal_visible: false,
      title: "",
      AttachmentUrl: "",
      AttachmentFileName: "",
      CompanyCode: this.$store.state.user.user.CompanySelected,
      form: {
        folderName: "",
        //  AttachmentUrl: this.fileList.Name,
        CreatedBy: this.$store.state.user.user.UserID,
        fileListResponse: []
      },
      columns: [
        {
          prop: "id",
          label: "NO",
          width: 500,
          sortable: true
        },
        {
          prop: "FolderName",
          label: "Descripcion",
          sortable: true
          // sortable: true,
          // formatter: row => {
          //   return row.ISODocumentProcess.Name;
          // }
        },
        // {
        //   prop: "CreatedAt",,
        //   label: "Fecha de creacion",
        //   sortable: true,
        //   formatter: DatetimeFormatter
        // },
        {
          prop: "AttachmentFileName",
          label: "Nombre del archivo",
          sortable: true
          // sortable: true,
          // formatter: row => {
          //   return row.ISODocumentProcess.Name;
          // }
        }
        // {
        //   prop: "AttachmentUrl",,
        //   label: "Documento",
        //   width: 150,
        //   sortable: true,
        //   formatter: DownLoadFile
        // }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        //   {
        //     icon: "el-icon-delete",
        //     label: "Eliminar",
        //     command: "delete"
        //   },
        {
          icon: "el-icon-edit",
          label: "editar",
          command: "edit"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    totalUploadFiles() {
      return this.$refs.uploadFile.uploadFiles.length;
    }
  },
  methods: {
    getData() {
      //for getting the data of the table for the first time
      const table = this.$refs.table;
      const config = {
        params: {
          ModuleId: this.ModuleId
        }
      };
      table.indexConfig = config;
    },
    callNew() {
      this.title = "Documentos Proveedores";
      this.legal_visible = true;
    },
    getTableData() {
      this.loading = true;
      this.$http
        .get("/api/Proyects/GetDocumentProviders", {
          params: {
            ModuleId: this.ModuleId
          }
        })
        .then((response) => {
          this.items = response.data;
          // console.log("klk data",this.items);
        })
        .finally(() => (this.loading = false));
    },
    actionHandler(action) {
      switch (action.command) {
        case "view": {
          this.downloadFile(action.row.AttachmentUrl);
          break;
        }
        case "delete": {
          if (this.IsInRoles([this.roles.SuperUsuario, this.roles.CEO])) {
            this.dialogVisible = true;
            this.fileId = action.row.id;
            this.fileCreatedBy = action.row.CreatedBy;
            this.selectedFile = action.row.id;
          } else {
            this.$message.error(
              "No tienes permiso para eliminar este documento"
            );
          }
          break;
        }

        case "edit": {
          this.dialogVisible2 = true;
          this.fileId = action.row.id;
          // console.log("el id klk",this.fileId );
          // console.log("companyCod",this.CompanyCode);
          this.getTableData();
          break;
        }
      }
    },

    handleUploadOnSuccess(response) {
      this.isEnabled = false;
      const items_count = response.length;
      for (var index = 0; index < items_count; index++) {
        if (items_count > 0) {
          this.fileList.push({
            name: response[index].Name,
            url: response[index].Url
          });
        }
      }
      //this.$refs.uploadFile.uploadFiles = [];
      this.count++;
      this.saves();
    },
    saveDocument() {
      this.$refs.form_create.validate((valid) => {
        if (valid) {
          this.$refs.uploadFile.submit();
          this.getTableData();
        } else {
          return false;
        }
      });
    },

    saves() {
      let self = this;
      self.fileList.forEach((listFiles) => {
        if (this.count === this.totalUploadFiles) {
          self.form.fileListResponse = self.fileList;
          var params = {
            id: this.fileId,
            folderName: this.folderName,
            AttachmentUrl: listFiles.url,
            AttachmentFileName: listFiles.name,
            ModifierBy: this.$store.state.user.user.UserID
          };
          self.$http
            .post("/api/Proyects/UpdateProvidersD", params)
            .then(() => {
              self.$emit("dialog-closed");
              self.$message({
                type: "success",
                message: "Archivo editado correctamente"
              });

              self.$emit("success");
            })
            .catch((err) => {
              self.$message({ type: "error", message: err.message });
              console.log("error");
            })
            .finally(() => {
              // self.count = 0;
              this.getTableData();
              this.fileList = [];
              this.folderName = "";
              this.dialogVisible2 = false;
              this.loading = false;
              self.$refs.form_create.resetFields();
            });
        }
      });
    },
    downloadFile(file) {
      let link = document.createElement("a");
      link.href = file;
      link.download = "download";
      link.target = "_blank";
      link.click();
    },
    deleteFile() {
      this.$http
        .get("api/Proyects/DeleteDocumentPrividers", {
          timeout: 3 * 60 * 1000,
          params: {
            "criteria.id": this.fileId,
            "criteria.CreatedBy": this.currentUser.UserID,
            "criteria.CurrentUserId": this.currentUser.UserID
          }
        })
        .then((response) => {
          if (response.data.Succeded) {
            let files = this.items.map(
              (item) => item.FileId == this.selectedFile
            );
            let deletedFileId = files.indexOf(true);
            this.items.splice(deletedFileId, 1);
            this.$message({
              type: "success",
              message: "El archivo fue eliminado exitosamente"
            });
          } else {
            this.$message.error("Solo el creador del archivo puede eliminarlo");
          }
        });
      this.dialogVisible = false;
    },
    updatePageSize(val) {
      this.pageSize = val;
      this.getTableData();
      this.save();
    },
    updateCurrentPage(val) {
      this.currentPage = val;
      this.getTableData();
      this.save();
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

#div-legal {
  position: relative;
  right: 23px;
  bottom: 18px;
}

#tablep {
  position: relative;
  bottom: 17px;
}
</style>
